export const Noticedata = [
   {
    id: 1,
    title: "공지 샘플 원단 무료 신청 안내",
    day: "2023-11-30",
    조회수: "조회 665"
  },
  {
    id: 2,
    title: "임시 휴무 안내",
    day: "2025-11-15",
    조회수: "조회 412"
  },
  {
    id: 3,
    title: "가격 인상 안내",
    day: "2025-10-23",
    조회수: "조회 527"
  },
  {
    id: 4,
    title: "원단 단종 안내",
    day: "2025-10-02",
    조회수: "조회 344"
  },
  {
    id: 5,
    title: "추석 휴무 안내",
    day: "2025-09-17",
    조회수: "조회 189"
  },
  {
    id: 6,
    title: "가격 인상 안내",
    day: "2025-08-04",
    조회수: "조회 245"
  },
  {
    id: 7,
    title: "가격 인상 안내",
    day: "2025-07-28",
    조회수: "조회 155"
  },
  {
    id: 8,
    title: "6월 운영 일정 안내",
    day: "2025-05-22",
    조회수: "조회 412"
  },
  {
    id: 9,
    title: "5월 휴무 안내",
    day: "2025-05-02",
    조회수: "조회 287"
  },
  {
    id: 10,
    title: "가격 인상 안내",
    day: "2025-04-30",
    조회수: "조회 351"
  },
  {
    id: 11,
    title: "배송 지연 안내",
    day: "2025-04-23",
    조회수: "조회 298"
  },
  {
    id: 12,
    title: "설날 휴무 안내",
    day: "2025-01-17",
    조회수: "조회 233"
  },
  {
    id: 13,
    title: "가격 인상 안내",
    day: "2025-01-15",
    조회수: "조회 264"
  },
  {
    id: 14,
    title: "배송 지연 안내",
    day: "2024-12-13",
    조회수: "조회 421"
  },
  {
    id: 15,
    title: "가격 인상 안내",
    day: "2024-11-25",
    조회수: "조회 178"
  },
  {
    id: 16,
    title: "임시 휴무 안내",
    day: "2024-10-25",
    조회수: "조회 332"
  },
  {
    id: 17,
    title: "현대백화점 충청점 변경 안내",
    day: "2024-08-02",
    조회수: "조회 165"
  },
  {
    id: 18,
    title: "가격 인상 안내",
    day: "2024-07-02",
    조회수: "조회 295"
  },
  {
    id: 19,
    title: "가격 인상 안내",
    day: "2024-04-30",
    조회수: "조회 244"
  },
  {
    id: 20,
    title: "가격 인상 안내",
    day: "2024-01-24",
    조회수: "조회 302"
  },
  {
    id: 21,
    title: "제품 가격 인상 안내",
    day: "2023-02-01",
    조회수: "조회 289"
  },
  {
    id: 22,
    title: "잭슨카멜레온 의왕 쇼룸 운영 종료 안내",
    day: "2022-11-28",
    조회수: "조회 187"
  },
  {
    id: 23,
    title: "연희 임시 쇼룸 종료 안내",
    day: "2022-11-03",
    조회수: "조회 256"
  }
];
